module.exports = __webpack_public_path__ + "static/media/dragIcon.931ec6c1.svg";